<template>
  <div class="users">
    <md-table
      v-model="users"
      md-sort="email"
      md-sort-order="asc"
      md-card>
      <md-table-toolbar>
        <span class="md-title">User management</span>
      </md-table-toolbar>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }">
        <md-table-cell
          md-label="ID"
          md-numeric
        >{{ item.id }}
        </md-table-cell>
        <md-table-cell
          md-label="Email"
          md-sort-by="email"
        >{{ item.email }}
        </md-table-cell>
        <md-table-cell
          md-label="Access"
          md-sort-by="access">{{ item.access }}
        </md-table-cell>

        <md-table-cell md-label="Delete">
          <md-button
            class="md-icon-button md-dense md-raised md-primary"
            @click="getConfirmationDeleteUser(item.email)">
            <md-icon>delete</md-icon>
          </md-button>

        </md-table-cell>

      </md-table-row>
    </md-table>

    <div>
      <md-button
        class="md-icon-button md-raised btn-addnewuser"
        @click="showAddNewUser = !showAddNewUser">
        <md-icon>add</md-icon>
      </md-button>
      <md-dialog :md-active.sync="showAddNewUser">
        <md-dialog-title>Add new user</md-dialog-title>
        <new-user v-model="newUser"/>
      </md-dialog>
    </div>

    <md-dialog-confirm
      :md-active.sync="active"
      md-title="Remove this user?"
      :md-content="`Do you really want to remove user<br><strong>${userToBeRemoved}</strong>?`"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"/>

    <md-snackbar :md-active.sync="submissionError">
      <template v-if="submissionErrorDetails">
        Error: {{ submissionErrorDetails.response.data.message }}
      </template>
    </md-snackbar>

  </div>
</template>
<script>

import NewUser from '@/components/NewUser.vue';

export default {
  components: {
    NewUser,
  },
  data() {
    return {
      newUser: null,
      users: [],
      active: false,
      userToBeRemoved: null,
      submissionError: false,
      submissionErrorDetails: null,
      showAddNewUser: false,
    };
  },

  created() {
    this.retrieveUsers();
  },
  watch: {
    newUser() {
      this.retrieveUsers();
    },
  },
  methods: {
    retrieveUsers() {
      this.$http.get(`${process.env.VUE_APP_BACKEND_URL}auth/users/`).then((response) => {
        this.users = response.data;
      });
    },
    onConfirm() {
      this.deleteUser(this.userToBeRemoved);
    },
    onCancel() {
      this.userToBeRemoved = null;
    },
    getConfirmationDeleteUser(email) {
      this.userToBeRemoved = email;
      this.active = true;
    },
    deleteUser(email) {
      const payload = {
        email,
      };

      this.$http.post(`${process.env.VUE_APP_BACKEND_URL}auth/unregister/`, payload)
        .then(() => {
          this.submissionError = false;
          this.submissionErrorDetails = null;
        })
        .catch((error) => {
          console.error(error);
          this.submissionError = true;
          this.submissionErrorDetails = error;
        })
        .finally(() => {
          this.retrieveUsers();
        });
    },
  },
};
</script>

<style lang="scss">
  .users {
    margin: 0 1rem;
  }
  .btn-addnewuser {
    margin: 1rem 0;
  }
</style>
